import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ArrowLeft as ArrowLeftIcon } from '@phosphor-icons/react';

export default function NotFound() {
    return (
        <Box component="main" sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center', minHeight: '100vh' }}>
            <Stack spacing={3} sx={{ alignItems: 'center', maxWidth: 'md' }}>
                <Box>
                    {/* Placeholder for image if not available, or just remove if no image */}
                    <Typography variant="h1" sx={{ textAlign: 'center', fontSize: '10rem', color: 'text.secondary' }}>
                        404
                    </Typography>
                </Box>
                <Typography variant="h3" sx={{ textAlign: 'center' }}>
                    404: The page you are looking for isn&apos;t here
                </Typography>
                <Typography color="text.secondary" variant="body1" sx={{ textAlign: 'center' }}>
                    You either tried some shady route or you came here by mistake. Whichever it is, try using the navigation
                </Typography>
                <Button
                    component={RouterLink}
                    to="/dashboard"
                    startIcon={<ArrowLeftIcon fontSize={20} />}
                    variant="contained"
                >
                    Go back to dashboard
                </Button>
            </Stack>
        </Box>
    );
}
